/**
 * Source Class Constants — Heart of Science v2
 * How projects are sourced (Academia, Founder, Corporate, Internal, Scouting)
 */

export const SOURCE_CLASS_CODES = [
  'ACADEMIA',
  'FOUNDER',
  'CORPORATE',
  'INTERNAL',
  'SCOUTING',
] as const;

export type SourceClass = typeof SOURCE_CLASS_CODES[number];

/**
 * Labels for source classes (frontend display)
 */
export const SOURCE_CLASS_LABELS: Record<SourceClass, string> = {
  ACADEMIA: 'Academia',
  FOUNDER: 'Founder',
  CORPORATE: 'Corporate',
  INTERNAL: 'Internal',
  SCOUTING: 'Scouting',
};
